import { useLayoutEffect } from 'react'

import { useTranslation } from 'react-i18next'

import { useSetGlassConfig } from '../../GlassConfigContext'
import styles from './ComplianceOverviewRightPanel.module.scss'
import preview from './assets/preview.webp'

export const ComplianceOverviewRightPanel = () => {
  const setGlassConfig = useSetGlassConfig()
  const { t } = useTranslation('translation', {
    keyPrefix:
      'desktop.full_page_onboarding.main_screen.steps.compliance_overview'
  })

  useLayoutEffect(() => {
    setGlassConfig?.(null)
  }, [setGlassConfig])

  return (
    <div className={styles.panel}>
      <div className={styles.preview}>
        <img
          className={styles.image}
          src={preview}
          alt={t('preview_alt')}
          draggable={false}
        />
      </div>
    </div>
  )
}
